@use "../../styles/breakpoint.module.scss" as *;

@mixin svg-style {
    width: 1em;
    height: 1em;
    fill: currentColor;
}

@mixin common-clickable {
    --height: 3.4em;

    align-items: center;
    display: inline-flex;
    font: var(--font-button);
    height: var(--height);
    justify-content: center;
    transition:
        background-color 0.3s ease-in-out,
        color 0.3s ease-in-out;

    &:disabled,
    &.disabled {
        opacity: 0.5;
        cursor: default;
    }

    & svg {
        @include svg-style;
    }
}

// things that we want on all clickables, including "unstyled" ones
.base {
    composes: outline from "../../styles/composable/utility.module.css";
}

.clickable {
    @include common-clickable;
}

@mixin filled-button {
    @include common-clickable;

    & .clickableContent,
    & :global(.clickableContent) {
        display: inline-flex;
        align-items: center;
        flex-direction: row;
        gap: 1.5em;
        flex-shrink: 0;
        padding-inline: 1.5em;
        text-align: center;
    }

    background-color: transparent;
    color: var(--color-contrast);
    box-shadow: inset 0 0 0 2px var(--color-contrast);
    overflow: hidden;

    &:hover:not(:disabled, .disabled) {
        background-color: var(--color-contrast);
        color: var(--color-text-contrast);
    }
}

.primaryButton {
    @include filled-button;
}

@mixin borderless-button {
    @include common-clickable;

    --height: auto;

    color: var(--color-text-primary);

    & .clickableContent,
    & :global(.clickableContent) {
        display: inline-block;

        svg {
            margin-left: 1.5em;
            transition: transform 0.3s ease-in-out;
            vertical-align: -0.2em;
        }
    }

    &:hover:not(:disabled, .disabled) {
        & .clickableContent svg,
        & :global(.clickableContent) svg {
            transform: translateX(0.5em);
        }
    }
}

.buttonSecondary {
    @include borderless-button;
}

// Pulled from thelab-ui to reset links in a richtext context
:global(:where(.linkReset)) {
    cursor: pointer;
    display: inline-block;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    text-decoration: none;
}

.playPauseButton {
    align-items: center;
    background-color: var(--black);
    border-radius: 50%;
    color: var(--white);
    font-size: var(--font-p-18);
    height: 120px;
    justify-content: center;
    position: absolute;
    text-transform: uppercase;
    width: 120px;
}
